// src/crm/conversations/channelMeta.ts
import type { MessageChannel, MessageDirection } from '../../lib/types'

export const CHANNEL_LABELS: Record<MessageChannel, string> = {
  email: 'Email',
  whatsapp: 'WhatsApp',
  instagram_dm: 'Instagram DM',
  tiktok_dm: 'TikTok DM',
  call: 'Appel',
  note: 'Note',
  other: 'Autre',
}

export const CHANNEL_COLORS: Record<MessageChannel, string> = {
  email: 'var(--bronze)',
  whatsapp: '#25D366',
  instagram_dm: '#C13584',
  tiktok_dm: '#010101',
  call: 'var(--arancio)',
  note: 'var(--muted)',
  other: 'var(--dim)',
}

export function channelLabel(channel: MessageChannel): string {
  return CHANNEL_LABELS[channel]
}

export function channelColor(channel: MessageChannel): string {
  return CHANNEL_COLORS[channel]
}

export function directionLabel(direction: MessageDirection): string {
  return direction === 'in' ? 'Entrant' : 'Sortant'
}
